import { ButtonTypeEnum, CmsComponentTypeEnum, MediaTypesEnum } from '@models/enums';
import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { Audio } from '@interfaces/config/cms-components/audio--config';
import { TImageConfig } from '@interfaces/media';

export namespace TextMediaBox {
  export const TypeEnum = CmsComponentTypeEnum.TEXT_MEDIA_BOX;

  export enum Order {
    TEXT_MEDIA = 'TEXT_MEDIA',
    MEDIA_TEXT = 'MEDIA_TEXT',
  }

  export enum Layout {
    STANDARD = 'STANDARD',
    SQUARED = 'SQUARED',
    BIG_IMAGE = 'BIG_IMAGE',
  }

  export interface MediaImageConfig extends TImageConfig {
    type: MediaTypesEnum.IMAGE;
    caption?: string;
  }

  export interface MediaVideoConfig {
    type: MediaTypesEnum.VIDEO;
    url: string;
    thumbnailNodeId?: string;
    thumbnail?: string;
    caption?: string;
    metas: { title?: string; description?: string };
  }

  export interface MediaYoutubeVideoConfig {
    type: MediaTypesEnum.YOUTUBE_VIDEO;
    videoId: string;
    caption?: string;
  }

  export interface MediaAudioConfig extends Audio.ComponentConfig {}

  export interface ComponentConfig extends BaseComponentConfig {
    order: Order;
    anchor_id?:string
    layout?: Layout;
    background?: boolean;
    headline?: string;
    body?: string;
    mediaLink?:{
      label: string;
      url: string;
   
    } 
    title: string;
    media: MediaImageConfig | MediaVideoConfig | MediaYoutubeVideoConfig | MediaAudioConfig;
    mediaSize?: 'small' | 'large';
    cta?: {
      label: string;
      url: string;
      buttonType?: ButtonTypeEnum;
      target?: '_self' | '_blank';
    };
   
  }
}
